import { useContext } from 'react';
import type { Send, Subscribe } from './messages';
import { StoreWebSocketContext } from './store-websocket-provider';

// Fail-fast: consumers must be inside a provider. Calling this hook outside
// `/stores/$storeId/*` is a bug — there is no meaningful default.
export function useStoreWebSocket(): { subscribe: Subscribe; send: Send } {
  const ctx = useContext(StoreWebSocketContext);
  if (!ctx) {
    throw new Error('useStoreWebSocket must be used within StoreWebSocketProvider');
  }

  return { subscribe: ctx.subscribe, send: ctx.send };
}
